import React, {useMemo, useRef} from "react";
import {useVehicleList} from "~/apps/packages/auto-visits/hooks";
import { Autocomplete, AutocompleteProps } from '@mui/material';
import {TextField, TextFieldProps} from "@mui/material";
import {humanizeVehicleNumber} from "~/apps/core/ui/VehicleNumber";
import {ArrayElement} from "~/types";
import {distinctByField} from "~/apps/core/utils";


export type Value = ArrayElement<ReturnType<typeof useVehicleList>["data"]>;


export type VehicleSelectProps = {
    value?: Pick<Value, "plateNumber">
    onChange?: (value: Value) => any
    additionalOptions?: Pick<Value, "plateNumber">[]
} & Omit<TextFieldProps, "value" | "onChange">;


export const VehicleSelect = (props: VehicleSelectProps) => {
    const {onChange, value, additionalOptions, ...otherProps} = props;
    const {data} = useVehicleList();
    const inputRef = useRef<HTMLInputElement>();
    const loading = !data;
    const availableValues: Value[] = useMemo(() => {
        return distinctByField([].concat(data).concat(additionalOptions).filter(Boolean), "plateNumber");
    }, [data, additionalOptions]);

    const handleChange = (e, value) => {
        inputRef?.current?.blur();
        onChange && onChange(value);
    }

    return (
        <Autocomplete
            {...otherProps as any as AutocompleteProps<Value, any, any, any>}
            value={value}
            onChange={handleChange}
            renderInput={props => (
                <TextField {...props} inputRef={inputRef} label="Транспорт" placeholder="Выбрать"/>
            )}
            getOptionLabel={option => humanizeVehicleNumber(option.plateNumber)}
            isOptionEqualToValue={(option, value) => value.plateNumber == option.plateNumber}
            options={availableValues}
            loading={loading}
            noOptionsText="Не найдено"
            loadingText="Загрузка..."
            blurOnSelect
        />
    );
}
